import { supabase } from "@/integrations/supabase/client";

/**
 * Camada de serviços do módulo Auth.
 * Funções puras que encapsulam chamadas ao Supabase Auth.
 * Não usam React, não exibem toasts — apenas executam e propagam erros.
 */

export interface SignUpInput {
  email: string;
  password: string;
  nome: string;
  orgaoId: string;
  role: string;
}

export async function signIn(email: string, password: string): Promise<void> {
  const { error } = await supabase.auth.signInWithPassword({ email, password });
  if (error) throw error;
}

export async function signUp(input: SignUpInput): Promise<void> {
  const { error } = await supabase.auth.signUp({
    email: input.email,
    password: input.password,
    options: {
      data: {
        nome: input.nome,
        orgao_id: input.orgaoId,
        role: input.role,
      },
      emailRedirectTo: window.location.origin,
    },
  });
  if (error) throw error;
}

export async function requestPasswordReset(email: string): Promise<void> {
  const { error } = await supabase.auth.resetPasswordForEmail(email, {
    redirectTo: `${window.location.origin}/reset-password`,
  });
  if (error) throw error;
}

export async function updatePassword(password: string): Promise<void> {
  const { error } = await supabase.auth.updateUser({ password });
  if (error) throw error;
}

export async function signOut(): Promise<void> {
  await supabase.auth.signOut();
}

export function subscribeToAuthStateChange(
  callback: (event: string) => void,
): () => void {
  const { data: { subscription } } = supabase.auth.onAuthStateChange(callback);
  return () => subscription.unsubscribe();
}

export interface OrgaoOption {
  id: string;
  nome: string;
}

export async function listOrgaosForSignup(): Promise<OrgaoOption[]> {
  const { data, error } = await supabase
    .from("orgaos")
    .select("id, nome")
    .order("nome");
  if (error) throw error;
  return data ?? [];
}
